<script lang="ts" setup>
  import { useTranslation } from '@/composables/useTranslation'

  // Define props
  interface Props {
    action: any // TAgentAction type from generated types
    customPayload?: any // Optional custom payload from child components
  }

  const props = defineProps<Props>()

  // Translation setup
  const { t } = useTranslation({
    en: {
      actionDetails: 'Action details will be displayed here.'
    },
    de: {
      actionDetails: 'Aktionsdetails werden hier angezeigt.'
    }
  })

  // Define emits for payload changes
  const emit = defineEmits<{
    payloadChanged: [payload: any]
  }>()
</script>

<template>
  <div>
    <!-- Action content slot -->
    <slot
      name="content"
      :action="action"
    >
      <!-- Default content if no slot provided -->
      <div>
        <h4 class="mb-2 text-sm font-medium text-gray-900">
          {{
            action.action_type
              .replace('_', ' ')
              .toLowerCase()
              .replace(/\b\w/g, (l) => l.toUpperCase())
          }}
        </h4>
        <p class="text-sm text-gray-600">
          {{ t('actionDetails') }}
        </p>
      </div>
    </slot>
  </div>
</template>

<style scoped></style>
